<template>

    <div>

		<el-row>
            <el-col :span="24">
                <p class="comfy-text s-16">Estás a dos minutos de confirmar tu reserva, empecemos:</p>
            </el-col>
        </el-row>

        <el-row class="mb-3" :gutter="10">

			<el-col :span="12">
				<el-select class="w-100" v-model="servicio.ciudad" clearable placeholder="Selecciona tu ciudad" size="large" @change="setCity($event)">
					<el-option
						v-for="item in cities"
						:key="item.id"
						:label="item.microciudad"
						:value="item.id">
					</el-option>
				</el-select>
			</el-col>

			<el-col :span="12" v-show="servicio.ciudad">
				<el-select class="w-100" v-model="servicio.datosDireccion.direccion" clearable placeholder="Selecciona tu dirección" size="large" @change="setAddress($event)">
					<el-option
						v-for="item in addresses"
						:key="item.id"
						:label="item.name + ': ' + item.street"
						:value="item.id">
					</el-option>
					<el-option
						label="Crear una nueva dirección"
						value="0">
					</el-option>
				</el-select>
			</el-col>

        </el-row>

		<GmapMap
			class="mb-3"
			v-if="showMap"
			:center="coordinates"
			:zoom="16"
			map-type-id="roadmap"
			style="width: 100%; height: 300px"
			:options="{
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
			}"
		>
			<GmapMarker
				:position="coordinates"
				:clickable="true"
				:draggable="true"
				:icon="{url: 'https://ivo-comfy.s3.amazonaws.com/assets/marker-location.png'}"
				@dragend="updateCoordinates"
			/>
		</GmapMap>

        <el-row class="mb-3" v-if="!servicio.cobertura && servicio.datosDireccion.direccion">

            <el-col :span="24">
                <p class="text-red font-weight-normal mb-0">No contamos con cobertura en la dirección seleccionada.</p>
            </el-col>

            <el-col :span="8" :offset="8">
                <vs-button
                    block
                    upload
                    icon
                    color="success"
                    flat
                    :active="active == 1"
                    @click="openWhatsapp()"
                    >
                    <i class="bx bxs-phone-call"></i> WhatsApp
                    <template>
                        <i class='bx bxs-like' ></i> escríbenos!
                    </template>
                </vs-button>
            </el-col>

        </el-row>

        <el-row class="mb-3" v-if="!coberturaMapa && showMap">
            <el-col :span="24" class="text-red font-weight-normal">No contamos con cobertura en la dirección seleccionada, es posible que el marcador se encuentre en un punto diferente a tu dirección, puedes probar moviéndolo hasta tu ubicación deseada y de nuevo confirmareros disponibilidad.</el-col>
        </el-row>

        <el-row class="mb-3" v-if="coberturaMapa && showMap">
            <el-col :span="24" class="comfy-text font-weight-normal">Contamos con cobertura en la dirección seleccionada, sin embargo te recomendamos mover el puntero si no concuerda con la ubicación deseada.</el-col>
        </el-row>

		<el-row class="mb-3" v-if="newAddressForm">
			<el-col :span="24">
				<div class="form-group mb-2">
					<i class="icon-add_location"></i>
					<label>Ingresa la dirección de tu reserva *</label>
					<el-input placeholder="Cra 15 # 78 - 80" autocomplete="on" name="address" v-model="fillAddress.address" @keyup.enter.native="checkAddress" clearable></el-input>
				</div>
				<div class="form-group mb-2">
					<i class="icon-location_city"></i>
					<label>Datos adicionales *</label>
					<el-input placeholder="Apartamento, casa, interior..." autocomplete="on" maxlength="189" show-word-limit name="optional" v-model="fillAddress.optional" @keyup.enter.native="checkAddress" clearable></el-input>
				</div>
				<div class="form-group mb-2">
					<i class="icon-loyalty"></i>
					<label>Nombre *</label>
					<el-select v-model="fillAddress.name" size="large" class="w-100">
						<el-option label="Apartamento" value="apartamento"></el-option>
						<el-option label="Casa" value="casa"></el-option>
						<el-option label="Oficina" value="oficina"></el-option>
						<el-option label="Trabajo" value="trabajo"></el-option>
						<el-option label="Pareja" value="pareja"></el-option>
						<el-option label="Familia" value="familia"></el-option>
						<el-option label="Otro" value="otro"></el-option>
					</el-select>
				</div>
				<div class="form-group mb-2">
					<i class="icon-location_city"></i>
					<label>Indícanos si es necesario el uso de ascensor *</label>
					<el-select v-model="fillAddress.ascensor" size="large" class="w-100">
						<el-option label="Sí, tenemos ascensor." value="si"></el-option>
						<el-option label="No, no tenemos ascensor. (Sin costo adicional)." value="no_necesario"></el-option>
					</el-select>
				</div>
				<div class="form-group mb-2">
					<i class="icon-location_city"></i>
					<label>Indícanos si cuentas con parqueadero gratuito *</label>
					<el-select v-model="fillAddress.parqueadero" size="large" class="w-100">
						<el-option :label="'No, no tengo parqueadero gratuito. (Sobrecosto de ' + ciudad_parqueadero + ').'" value="no" selected></el-option>
						<el-option label="Sí, tengo parqueadero gratuito." value="si"></el-option>
					</el-select>
				</div>
				<div class="form-group" v-if="!saveAddressButton">
					<button class="btn btn-sm btn-block comfy rounded-big cursor-pointer text-white" @click="checkAddress" v-loading.fullscreen.lock="fullscreenLoading">Confirmar dirección</button>
				</div>
				<div class="form-group" v-if="saveAddressButton">
					<button class="btn btn-sm btn-block comfy rounded-big cursor-pointer text-white" @click="saveAddressForm">Guardar dirección</button>
				</div>
			</el-col>
		</el-row>

    </div>

</template>

<script>
    import * as VueGoogleMaps from 'vue2-google-maps'
    window.Vue.use(VueGoogleMaps, {
        load: {
            key: process.env.MIX_GOOGLE_MAPS_GEOCODING_API_KEY,
            libraries: 'places',
            region: 'CO',
            language: 'es',
        }
    });

	export default {
        props: [
            'servicio',
			'cliente'
        ],
        data() {
            return {
				cities: [],
				ciudad_parqueadero: '$10.000',
				addresses: [],
				newAddressForm: false,
				fillAddress: {
					address: '',
					optional: '',
					name: 'apartamento',
				},
				coberturaMapa: false,
				coordinates: {
					lat: '',
					lng:''
				},
				showMap: false,
				fullscreenLoading: false,
				saveAddressButton: false,
				pasoUno: false,
                active: 1,
            }
        },
        watch: {
			'fillAddress.address': function(val, oldVal){
				this.saveAddressButton = false
			},
			'servicio.cobertura': function(val, oldVal){
				if(this.servicio.cobertura && this.servicio.datosDireccion.direccion){
					// console.log('--- paso uno completado ---')
					this.pasoUno = true
				}else{
					// console.log('--- paso uno incompleto ---')
					this.pasoUno = false
				}
			},
			'pasoUno': function(val, oldVal){
				if(this.pasoUno){
					let params = {
						status: true,
						ciudad: this.servicio.ciudad,
						direccion: this.servicio.datosDireccion.direccion,
						parqueadero: this.servicio.datosDireccion.parqueadero,
						ascensor: this.servicio.datosDireccion.ascensor
					}
					this.$emit('status', params)
				}else {
					let params = {
						status: false,
						ciudad: this.servicio.ciudad,
						direccion: this.servicio.datosDireccion.direccion,
						parqueadero: this.servicio.datosDireccion.parqueadero,
						ascensor: this.servicio.datosDireccion.ascensor
					}
					this.$emit('status', params)
				}
			},
			'servicio.ciudad': function(val, oldVal){
				// cuando cambie ciudad, debemos buscar en this.cities para obtener el valor de parqueadero
				this.cities.forEach((city) => {
					if(city.id == val){
						this.ciudad_parqueadero = city.parqueadero.toLocaleString('es-CO', {style: 'currency', currency: 'COP'})
						this.ciudad_parqueadero = this.ciudad_parqueadero.replace(',00', '')
					}
				});
			}
        },
        methods: {
			popupConfirmarMapa() {
				Swal.fire({
					title: `<span class="text-danger">¡IMPORTANTE!</span>`,
                    iconColor: '#18333d',
                    text: 'Verifica la posición del cursor en el mapa que verás a continuación. Debe estar en el lugar exacto de tu dirección. Este paso es clave para que tu Pro llegue al lugar correcto y a tiempo.',
                    showConfirmButton: true,
                    timerProgressBar: true
                })
			},
            openWhatsapp: function(){
                window.open("https://api.whatsapp.com/send?phone=573147875335&text=Hola%20Comfy,%20no%20tengo%20cobertura%20en%20mi%20zona", "_blank");
            },
			getCities(){
				// console.log('--- obteniendo ciudades ---')
				var url = '/get-cities'
				axios.post(url).then(response => {
                    this.cities = response.data.cities
                })
				var getCiudad = new URL(location.href).searchParams.get('ciudad')
				if(getCiudad){
					var cityId = parseInt(getCiudad)
					this.servicio.ciudad = cityId
					this.setCity(cityId)
				}
			},
			setCity(id){
				this.addresses = []
				this.servicio.datosDireccion.direccion = ''
				this.newAddressForm = false
				this.servicio.cobertura = false
				EventBus.$emit('changeSelectAddress')
				this.getAnticipado(id);
				if(id != this.servicio.ciudad){
					return
				}

				var url = '/cliente/direcciones'
				axios.post(url, {
					city_id: id
				}).then(response => {
					// console.log('--- obteniendo direcciones del cliente en la ciudad ---')
					if(response.data.code == 403){
							// console.log('--- usuario no registrado ---')
							return
					}
                    // console.log(response.data.addresses)
                    this.addresses = response.data.addresses
                }).catch(error => {
                    if(error.response.status == 401){
                        this.servicio.ciudad = ''
                        alert('Tu cuenta ha sido bloqueada, comunícate con nuestro canal de atención al cliente')
                    }
                })
			},
			setAddress(id){
				this.showMap = false
				this.servicio.cobertura = false
				this.newAddressForm = false
				this.coberturaMapa = false
				this.servicio.datosDireccion.parqueadero = ''
				this.servicio.datosDireccion.ascensor = ''
				this.servicio.datosDireccion.valorAscensor = ''
				this.servicio.datosDireccion.valorParqueadero = ''
				this.servicio.precioParqueadero = 0
				this.servicio.precioAscensor = 0
				EventBus.$emit('changeSelectAddress')
				if(id == '0'){
					// console.log('--- crear nueva dirección ---')
					this.newAddressForm = true
					this.servicio.datosDireccion.direccion = ''
					return
				}
				// console.log('--- confirmar cobertura de dirección ---')
				var url = '/cliente/confirmar-cobertura-direccion'
				axios.post(url, {
					city_id: this.servicio.ciudad,
					address_id: id
				}).then(response => {
					// console.log('--- verificando cobertura de dirección seleccionada ---')
					// console.log(response.data)
					if(!response.data.inside){
						this.servicio.cobertura = false
						this.$message({
							message: 'Upss, no tenemos cobertura en esa dirección.',
							type: 'error'
						});
					}else{
						this.servicio.cobertura = true
						this.servicio.datosDireccion.parqueadero = response.data.parqueadero
						this.servicio.datosDireccion.ascensor = response.data.ascensor
						this.servicio.datosDireccion.valorAscensor = response.data.valorAscensor
						this.servicio.datosDireccion.valorParqueadero = response.data.valorParqueadero
						// console.log(this.servicio.datosDireccion)
					}
				})
			},
            getAnticipado(id){
                axios.get(`/get-anticipado/${id}`).then(response => {
                    this.servicio.anticipadoPorcentaje = response.data.porcentaje
                    this.servicio.anticipadoHoras = response.data.horas
                    this.servicio.anticipadoValor = 0
                }).catch(error => {
                    this.servicio.anticipadoPorcentaje = 0
                    this.servicio.anticipadoHoras = 0
                    this.servicio.anticipadoValor = 0
                })
            },
			checkAddress(){
				this.fullscreenLoading = true
				this.conCobertura = false
				this.sinCobertura = false
				this.showMap = false
				this.coberturaMapa = false
				this.saveAddressButton = false
				if(!this.fillAddress.address){
					this.fullscreenLoading = false
					this.$message({
						message: 'Upss, debes indicarnos una dirección.',
						type: 'error'
					})
					return
				}
				if(!this.fillAddress.optional){
					this.fullscreenLoading = false
					this.$message({
						message: 'Upss, debes añadir indicaciones de tu dirección.',
						type: 'error'
					})
					return
				}
				if(this.cliente == '0'){
					// console.log('--- debes iniciar sesión ---')
					this.fullscreenLoading = false
					$('#modalLogin').modal('show')
					return
				}
				// console.log('--- abriendo mapa de georeferencia ---')
				var url = '/cliente/confirmar-direccion'
				axios.post(url, {
					city_id: this.servicio.ciudad,
					address: this.fillAddress.address
				}).then(response => {
					// console.log(response.data)
					this.fullscreenLoading = false
					this.coordinates = {
						lat: response.data.geocode.lat,
						lng: response.data.geocode.lng
					}
					if(!response.data.inside){
						this.coberturaMapa = false
					}else{
						this.coberturaMapa = true
						this.saveAddressButton = true
					}
					this.showMap = true
					this.popupConfirmarMapa()
				}).catch(error => {
					console.log(error)
				})
			},
			updateCoordinates(location){
				// console.log('--- confirmar ubicación por draggable ---')
				this.saveAddressButton = false
				this.coordinates = {
					lat: location.latLng.lat(),
					lng: location.latLng.lng(),
				};
				var url = '/cliente/confirmar-direccion-draggable'
				axios.post(url, {
					city_id: this.servicio.ciudad,
					lat: location.latLng.lat(),
					lng: location.latLng.lng(),
				}).then(response => {
					if(response.data.inside){
						this.coberturaMapa = true
						this.saveAddressButton = true
					}else {
						this.coberturaMapa = false
					}
				}).catch(error => {
					console.log(error)
				})
			},
			saveAddressForm(){
				// console.log('--- guardar dirección cliente ---')
				if(!this.saveAddressButton){
					return
				}
				var url = '/cliente/guardar-direccion'
				axios.post(url, {
					city_id: this.servicio.ciudad,
					lat: this.coordinates.lat,
					lng: this.coordinates.lng,
					address: this.fillAddress.address,
					optional: this.fillAddress.optional,
					name: this.fillAddress.name,
					parqueadero: this.fillAddress.parqueadero,
					ascensor: this.fillAddress.ascensor
				}).then(response => {
					console.log(response.data)
					this.addresses.push(response.data.address)
					this.servicio.datosDireccion.direccion = response.data.address.id
					this.servicio.datosDireccion.parqueadero = response.data.address.parqueadero
					this.servicio.datosDireccion.ascensor = response.data.address.ascensor
					this.servicio.datosDireccion.valorparqueadero = response.data.valorParqueadero
					this.servicio.datosDireccion.valorascensor = response.data.valorAscensor
					this.showMap = false
					this.newAddressForm = false
					this.setAddress(response.data.address.id)
				}).catch(error => {
					console.log(error)
				})
			}
        },
        mounted() {
            // console.log('--- Ubicacion component mounted ---')
            this.getCities()
            EventBus.$on('authUser', data => {
                this.newAddressForm = false
            })
        }
    }
</script>

<style>
.el-select-dropdown__item.selected {
    color: #18333d;
}
@media screen and (max-width: 600px) {
	.el-message-box__wrapper {
		left: 10px;
		right: 10px;
	}
	.el-message-box {
		width: auto;
	}
}
</style>